<template>
    <b-list-group-item
        :active="active"
        :to="to"
        class="rkm-sidebar-list-group-item"
    >
        <rkm-icon
            v-if="icon"
            :icon="icon"
            class="rkm-sidebar-list-group-item-icon"
        />

        <div class="rkm-sidebar-list-group-item-title">
            {{ title }}
        </div>

        <rkm-icon
            v-if="!to"
            class="rkm-sidebar-list-group-item-icon-arrow"
            icon="caret-right"
        />
    </b-list-group-item>
</template>

<script>
// Components.
import {BListGroupItem} from 'bootstrap-vue'

export default {
    components: {BListGroupItem},
    props: {
        active: { type: Boolean },
        icon: { type: [Array, Object, String] },
        title: { type: String },
        to: { type: [Object, String] },
    },
}
</script>

<style lang="scss" scoped>
$primary: #007bff;

.active {
    background: none !important;
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-list-group-item {
    align-items: center;
    border: none;
    color: #222222;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 600;
    justify-content: space-between;
    width: 100%;
    background: none !important;
}
.rkm-sidebar-list-group-item-active {
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-list-group-item:hover {
    color: darken($primary, 10%) !important;
}
.rkm-sidebar-list-group-item-icon {
    margin-right: 15px;
}
.rkm-sidebar-list-group-item-title {
    margin-right: auto;
}
.rkm-sidebar-list-group-item-icon-arrow {
    margin-left: 15px;
}
</style>